export default __webpack_public_path__ + "static/6834-b8970ad620eddc4c8d67cec9071ef3e8.jpg";